import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";

export class Hydra1ChartJS extends AlgoBase {

  constructor(target, graphIndex = 1) {
    super("hydra", target);
    this.graphIndex = graphIndex;
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Hydra1and2.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'CHW Supply Temp Setpoint', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#6400FF',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                title: "Maximum reset", // [dynamic value in loadDataset()],
                yMin: 0, // [dynamic value in loadDataset()],
                yMax: 0, // [dynamic value in loadDataset()],
                borderColor: '#EB2B31',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
              line2: {
                type: 'line',
                title: "Minimum reset", // [dynamic value in loadDataset()],
                yMin: 0, // [dynamic value in loadDataset()],
                yMax: 0, // [dynamic value in loadDataset()],
                borderColor: '#000000',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
            },
          },
          title: {
            display: true,
            text: '-', // [dynamic value in loadDataset()],
          }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 3),
          y: {
            // min: [dynamic value in loadDataset()],
            // max: [dynamic value in loadDataset()],
            ticks: {
              callback: (value, index, ticks) => {
                return this.temperatureLegend(value); // Append the unit
              }
            },
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    const offset = (this.aiEnabled ? 0 : this.getLoopIndex());

    // Update data for preferred unit
    this.algortihmData.mainDatasets[datasetIndex + offset] = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[0][datasetIndex + offset])

    // Update y limits for preferred unit
    if (this.preferredUnit === "celsius") {
      this.chart.options.scales.y.min = 2
      this.chart.options.scales.y.max = 12
      this.chart.options.plugins.annotation.annotations.line1.yMax = this.fahrenheitToCelsius(52)
      this.chart.options.plugins.annotation.annotations.line2.yMax = this.fahrenheitToCelsius(42)
    } else {
      this.chart.options.scales.y.min = 40
      this.chart.options.scales.y.max = 54
      this.chart.options.plugins.annotation.annotations.line1.yMax = 52
      this.chart.options.plugins.annotation.annotations.line2.yMax = 42
    }

    // Keep annotation lines horizontal (flat)
    this.chart.options.plugins.annotation.annotations.line1.yMin = this.chart.options.plugins.annotation.annotations.line1.yMax
    this.chart.options.plugins.annotation.annotations.line2.yMin = this.chart.options.plugins.annotation.annotations.line2.yMax;

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, this.graphIndex);
    this.chart.options.plugins.annotation.annotations.line1.title = this.getLegendFromCMS(2, this.graphIndex);
    this.chart.options.plugins.annotation.annotations.line2.title = this.getLegendFromCMS(3, this.graphIndex);

    this.chart.options.plugins.title.text = this.getLegendFromCMS(4, this.graphIndex)?.toUpperCase();

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    return await super.buildDatasetFromCSV(filename, 2);
  }

}
